import React from 'react';
import Logo from '../../images/kaeufer-plus-charcoal.svg';
import { useIntl } from '@/i18n';

const styles = {
  logo: {
    height: 21,
    marginTop: -4,
  },
};

export const BuyerPlusLogo = () => {
  const { t } = useIntl();

  return (
    <img
      className='align-middle'
      src={Logo}
      alt={t({
        id: 'common.buyerPlusImgAlt',
        defaultMessage: 'Käufer plus',
      })}
      style={styles.logo}
    />
  );
};
